export default "__VITE_ASSET__DkyOIOY8__"